export const LOCATOR_ALERTS = {
  THEFT_RECOVERY_ACTIVATING: 'theftRecoveryActivating',
  THEFT_RECOVERY_ACTIVATED: 'theftRecoveryActivated',
  THEFT_RECOVERY_ENDING: 'theftRecoveryEnding',
  END_OF_LIFE: 'endOfLife',
  NON_OPERATIONAL: 'non-operational',
  NOT_REPORTING: 'not-reporting',
  DEVICE_HEALTH: 'deviceHealthProblem',
  PENDING_AUTOMATIC_LOCATION_TRANSFER: 'automaticLocationTransfer',
  POSITION_PENDING: 'positionPending'
};
export const HEARTBEAT_INTERVALS = [60, 120, 150, 180, 300, 900, 1800, 3600, 7200, 43200, 61200, 81900, 86400];
export const DEFAULT_HEARTBEAT_INTERVAL = 7200;